import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import camelCase from 'lodash/camelCase';
import { FEATURE_FLAGS } from './feature-flags';

export type FeatureFlagValue = typeof FEATURE_FLAGS[keyof typeof FEATURE_FLAGS];

export function useFeatureFlag(flagValue: FeatureFlagValue): boolean;
export function useFeatureFlag<T>(flagValue: FeatureFlagValue, defaultValue: T): T;
export function useFeatureFlag<T>(flagValue: FeatureFlagValue, defaultValue: T | boolean = false): T | boolean {
    const flags = useFlags();
    const ldClient = useLDClient();
    const flagKey = camelCase(flagValue); //flag keys are returned in camelCase format, convert accordingly

    // If LaunchDarkly is not initialized, return default value
    if (!ldClient) {
        return defaultValue;
    }

    // get flag value, fallback to default if not found
    return flags[flagKey] ?? defaultValue;
}
